module.exports = __webpack_public_path__ + "static/media/invite-user-mobile.69aaccab.svg";